export const buttonNameConstants = {
  NO: "No",
  YES: "Yes",
  ADD: "Add",
  PAY: "Pay",
  SAVE: "Save",
  CASH: "Cash",
  OPEN: "Open",
  TEXT: "Text",
  BACK: "Back",
  EDIT: "Edit",
  SCAN: "Scan",
  RESET: "Reset",
  TOTAL: "Total",
  EMAIL: "Email",
  LOGIN: "Login",
  CLEAR: "Clear",
  PRINT: "Print",
  APPLY: "Apply",
  VALUE: "Value",
  CLOSE: "Close",
  OTHER: "Other",
  SPLIT: "Split",
  SUBMIT: "Submit",
  SEARCH: "Search",
  MANAGE: "Manage",
  CANCEL: "Cancel",
  DELETE: "Delete",
  UPDATE: "Update",
  SCAN_ID: "Scan ID",
  BROWSER: "Browse",
  DISMISS: "Dismiss",
  PRINTER: "Printer",
  PERCENT: "Percent",
  DISCARD: "Discard",
  CONNECT: "Connect",
  CONFIRM: "Confirm",
  ADD_ITEM: "Add Item",
  NEW_SALE: "New Sale",
  ADD_TYPE: "Add Type",
  COMPLETE: "Complete",
  COMPLETED: "Completed",
  CANCELED: "Canceled",
  NOT_STARTED: "Not Started",
  IN_PROGRESS: "In Progress",
  CONTINUE: "Continue",
  TRANSFER: "Transfer",
  ADD_CASH: "Add Cash",
  CONNECTED: "Connected",
  SUBSCRIBE: "Subscribe",
  PRINT_ALL: "Print All",
  NEW_TRADE: "New Trade",
  ADD_BATCH: "Add Batch",
  VIEW_ORDER: "View Order",
  PARK_SALE: "Park Sale",
  ADD_VENDOR: "Add Vendor",
  SEND_EMAIL: "Send Email",
  SAVE_BATCH: "Save Batch",
  CHANGE_PIN: "Change Pin",
  EXPORT_CSV: "Export CSV",
  IMPORT_CSV: "Import CSV",
  EBAY_SALES: "eBay Sales",
  PARK_TRADE: "Park Trade",
  ADD_INVOICE: "Add Invoice",
  START_AUDIT: "Start Audit",
  NICK_NAME: "Nickname",
  REMOVE_CASH: "Remove Cash",
  BULK_UPDATE: "Bulk Update",
  DISMISS_ALL: "Dismiss All",
  ADD_TO_CART: "Add to Cart",
  CREDIT_CARD: "Credit Card",
  PLEASE_WAIT: "Please Wait",
  VIEW_INVOICE: "View Invoice",
  REPORT_A_BUG: "Report a Bug",
  ITEM_HISTORY: "Item History",
  ACTIVITY_LOG: "Activity Log",
  ISSUE_REFUND: "Issue Refund",
  START_IMPORT: "Start Import",
  IMPORT_USERS: "Import Users",
  GIFT_RECEIPT: "Gift Receipt",
  RETRIEVE_SALE: "Retrieve Sale",
  ADD_CATEGORY: "Add Category",
  CHANGE_PRICE: "Change Price",
  ADD_CUSTOMER: "Add Customer",
  STORE_CREDIT: "Store Credit",
  TEST_PRINTER: "Test Printer",
  CHECK_STATUS: "Check Status",
  VIEW_DETAILS: "View Details",
  MARK_AS_OPEN: "Mark as Open",
  MARK_AS_READY: "Mark as Ready",
  SAVE_AS_DRAFT: "Save as Draft",
  SAVE_AND_EXIT: "Save & Exit",
  DISCARD_AND_EXIT: "Discard & Exit",
  OPEN_REGISTER: "Open Register",
  ZERO_ITEMS: "Zero Items",
  IGNORE_ITEMS: "Ignore Items",
  PRINT_LABEL: "Print Label(s)",
  ADD_INVENTORY: "Add Inventory",
  SAVE_MAPPINGS: "Save Mappings",
  GIFT_CARD_PAYMENT: "Gift Card",
  CUSTOM_ITEM: "Add Custom Item",
  PRINT_RECEIPT: "Print Receipt",
  RETRIEVE_TRADE: "Retrieve Trade",
  REPORT_PROBLEM: "Report Problem",
  CONTINUE_BATCH: "Continue Batch",
  QUICK_TRADE_ID: "Quick Trade-In",
  PRICE_CHARTING: "Price Charting",
  DASHBOARD: "Return To Dashboard",
  GIFT_CARD: "Sell/Load Gift Card",
  INSERT_VARIABLE: "Insert Variable",
  LINK_TO_SHOPIFY: "Link to Shopify",
  FULFILL_INVOICE: "Fulfill Invoice",
  ADD_CUSTOM_ITEM: "Custom Item",
  USE_MARKET_PRICE: "Use Market Price",
  IMPORT_CUSTOMER: "Import Customers",
  EXPORT_CUSTOMER: "Export Customers",
  ADD_NEW_PRINTER: "Add new Printer",
  CHANGE_PASSWORD: "Change Password",
  VIEW_EBAY_SALES: "eBay Sales",
  FILTER_SETTINGS: "Filter Settings",
  MARK_ALL_AS_READ: "Mark all as read",
  OPEN_CASH_DRAWER: "Open Cash Drawer",
  ADD_TO_INVENTORY: "Add to Inventory",
  PRINT_TEST_LABEL: "Print Test Label",
  ADD_SUB_CATEGORY: "Add Sub-Category",
  TEST_CASH_DRWAER: "Test Cash Drawer",
  NEW_AUDIT_SESSION: "New Audit Session",
  VIEW_TCG_PLAYER: "View TCGplayer Page",
  MARK_AS_FULFILLED: "Mark as Fulfilled",
  EDIT_FIELD_MAPPING: "Edit Field Mapping",
  PRINT_TEST_RECEIPT: "Print Test Receipt",
  VIEW_PRICE_CHARTING: "Pricecharting",
  EDIT_SHOPIFY_PRESET: "Edit Shopify Preset",
  SET_DEFAULT_PRINTER: "Set Default Printer",
  CANCEL_SUBSCRIPTION: "Cancel Subscription",
  GRANT_FREE_MONTH: "Grant Free Month(s)",
  TEST_DEFAULT_PRINTER: "Test Default Printer",
  FORCE_CLOSE_REGISTER: "Force Close Register",
  PRINT_PRODUCT_LABEL: "Print Label(s)",
  CONFIGURE_MERCHANT: "Configure Merchant",
  CONNECT_PAYRILLIUM: "Connect Payrillium Device",
  CANCEL_THE_TRANSACTION: "Cancel the Transaction",
  SEARCH_COMPANY_INVENTORY: "Search Company Inventory",
  RESET_CUSTOMER_CREDIT: "Reset Customer’s Store Credit",
  SEPARATE_QUANTITY: "Separate In-Store & Online Quantities",
  DIFFERENT_ONLINE_PRICE: "Different Online Price",
  TRANSFER_CUSTOMER_CREDIT: "Transfer Customer’s Store Credit",
  SAVE_PASSWORD: "Save Password",
  ADD_CURRENT_DEVICE_AS_OUTLET: "Add the Current Device as an Outlet",
  TRANSFER_TO_LOCATION: "Transfer to Location",
  MARK_AS_IN_PROGRESS: "Mark as In Progress",
  MARK_AS_COMPLETED: "Mark as Completed",
  DOWNLOAD_FAILED_PRODUCTS: "Download failed products",
};

export const buttonTypeConstants = {
  GREEN_BUTTON: "GREEN_BUTTON",
  RED_BUTTON: "RED BUTTON",
  BLUE_BUTTON: "BLUE BUTTON",
  BLACK_BUTTON: "BLACK BUTTON",
  GHOST_BUTTON: "GHOST BUTTON",
  LIGHT_PURPLE: "LIGHT PURPLE",
  ACTION_BUTTON: "ACTION BUTTON",
  GHOST_BUTTON_2: "GHOST BUTTON 2",
  LOADING_BUTTON: "LOADING BUTTON",
  RED_BUTTON_FILL: "RED BUTTON_FILL",
  TOP_BAR_TOGGLE_BUTTON: "TOP_BAR_TOGGLE_BUTTON",
  TRANSPARENT_BUTTON_GHOST: "TRANSPARENT_BUTTON_GHOST",
  TRANSPARENT_BUTTON_PURPLE: "TRANSPARENT_BUTTON_PURPLE",
};
